// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1394":"772f6096","7318":"cc668609","7627":"39bc3d9f"}[chunkId] + ".chunk.css";
};